const kashika6Options = [
    {
        menuName: "道路に関する情報",
        options: [
            {
                label: "本日の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_1",
                url:process.env.REACT_APP_DOROKISEI_1
            },
            {
                label: "今後の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_2",
                url:process.env.REACT_APP_DOROKISEI_2
            },
            {
                label: "事前通行規制区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_3",
                url:process.env.REACT_APP_DOROKISEI_3
            },
            {
                label: "走行注意区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_4",
                url:process.env.REACT_APP_DOROKISEI_4
            },
            {
                label: "緊急輸送道路",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_5",
                url:process.env.REACT_APP_DOROKISEI_5
            },  
            {
                label: "道路カメラ・冬季道路情報",
                type: "marker",
                dataset_id: 3,
                id: "sekisetusin_6_10",
                url:process.env.REACT_APP_SEKISETUSIN_6_10
            },
        ]
    },
  
    {
        menuName: "インフラ情報（道路）",
        options: [
            {
                label: "橋梁",
                type: "marker",
                dataset_id: 22,
                id: "kyoryo",
                url:process.env.REACT_APP_SPOT_14_KYORYO
            },
            {
                label: "横断歩道橋",
                type: "marker",
                dataset_id: 22,
                id: "hodokyo",
                url:process.env.REACT_APP_SPOT_14_HODOKYO
            },
            {
                label: "トンネル",
                type: "marker",
                dataset_id: 23,
                id: "tunnel",
                url:process.env.REACT_APP_SPOT_15_TUNNEL
            },
            {
                label: "門型標識",
                type: "marker",
                dataset_id: 25,
                id: "doro-mongata",
                url:process.env.REACT_APP_SPOT_16_2_ROAD
            },
            {
                label: "シェッド",
                type: "marker",
                dataset_id: 24,
                id: "doro-shed",
                url:process.env.REACT_APP_SPOT_16_1_ROAD
            },
            {
                label: "道路台帳附図",
                type: "marker",
                id: "vis_92",
                url:process.env.REACT_APP_SPOT_92
            },
        ]
    },
  
];

export  {
    kashika6Options
};
